import { themes } from '@/theme';
import { Box, Drawer } from '@mui/material';
import { Avatar } from './avatar';
import { NavigationList } from './navigationlist';

export const AppDrawer = () => {
	return (
		<Box sx={{ display: 'flex', flex: 1 }}>
			<Drawer
				variant='permanent'
				PaperProps={{
					sx: {
						position: 'inherit',
						backgroundColor: themes.lightTheme.palette.primary.main,
						color: 'white'
					}
				}}>
				<NavigationList />
				<Avatar />
			</Drawer>
		</Box>
	);
};
